
export default class HashGen {

    static regular(pattern = null) {
        return (pattern || 'xxyyyxxyyy').replace(/[xy]/g, c => {
            let chars = 'abcdefghijklmnopqrstuvwxyz';
            let digits = '0123456789'
    
            return c === 'x' 
                ? chars.charAt(Math.floor(Math.random() * chars.length)) 
                : digits.charAt(Math.floor(Math.random() * digits.length))
        })
    }

    static double() {
        return HashGen.regular() + HashGen.regular();
    }

    static uuid4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          let r = Math.random() * 16 | 0
          let v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
    }
}
